import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Orientation, PopupSubMenu, PopupSubMenuIconContainer } from "../../menu/PopupSubMenu";
import { AiFillSound } from "react-icons/ai";
import { SoundSelectionDetail } from "../details/components/SoundSelectionDetail";
import { SoundCache, soundCache } from "../../../stores/SoundCache";
const Button = styled.button.withConfig({
  displayName: "SoundSelectionButton__Button",
  componentId: "sc-2694ok-0"
})(["cursor:pointer;"]);
const Row = styled.div.withConfig({
  displayName: "SoundSelectionButton__Row",
  componentId: "sc-2694ok-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
const ButtonContainer = styled.div.withConfig({
  displayName: "SoundSelectionButton__ButtonContainer",
  componentId: "sc-2694ok-2"
})(["display:flex;flex-direction:row;justify-content:center;padding-top:8px;"]);
export const SoundSelectionButton = observer(props => {
  const {
    t
  } = useTranslation();
  const [soundPaths] = useState(props.filterForSoundPrefix ? SoundCache.filterForPrefix(soundCache.getSoundPaths(), props.filterForSoundPrefix) : soundCache.getSoundPaths());
  const [selectionCandidatePath, setSelectionCandidatePath] = useState(props.selectedPath);
  const [selectionCandidateParameter, setSelectionCandidateParameter] = useState(props.selectedTreeParameter);

  function onSelectSoundPath(path) {
    setSelectionCandidatePath(path);
    setSelectionCandidateParameter(null);
  }

  function onSelectSoundParameter(parameter) {
    setSelectionCandidateParameter(parameter);
    setSelectionCandidatePath(null);
  }

  function onClickApply() {
    var _props$onSelectTreePa2;

    if (!selectionCandidatePath && !selectionCandidateParameter) {
      var _props$onSelectTreePa;

      props.onSelectSoundPath(null);
      (_props$onSelectTreePa = props.onSelectTreeParameter) === null || _props$onSelectTreePa === void 0 ? void 0 : _props$onSelectTreePa.call(props, null);
    }

    if (selectionCandidatePath) props.onSelectSoundPath(selectionCandidatePath);else (_props$onSelectTreePa2 = props.onSelectTreeParameter) === null || _props$onSelectTreePa2 === void 0 ? void 0 : _props$onSelectTreePa2.call(props, selectionCandidateParameter);
  }

  return /*#__PURE__*/React.createElement(Row, null, props.text, /*#__PURE__*/React.createElement(PopupSubMenu, {
    orientation: Orientation.Left,
    relativeOffset: 0,
    containerWidth: `400px`,
    buttonContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopupSubMenuIconContainer, null, /*#__PURE__*/React.createElement(AiFillSound, null)), props.selectedPath ? props.selectedPath.name : t("editor.map_background_sound_select")),
    buttonInvalid: !props.allowBlankValue && !props.selectedPath && !props.selectedTreeParameter,
    onOpen: () => {},
    positionFixed: true,
    childrenWithCallbacks: closePopup => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SoundSelectionDetail, {
      onSelectPath: onSelectSoundPath,
      selectedPath: selectionCandidatePath,
      soundPaths: soundPaths,
      action: props.action,
      onSelectTreeParameter: onSelectSoundParameter,
      selectedTreeParameter: selectionCandidateParameter,
      showEmptyStateAsInvalid: !props.allowBlankValue
    }), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
      onClick: () => {
        onClickApply();
        closePopup();
      }
    }, t("editor.map_background_sound_select")), /*#__PURE__*/React.createElement(Button, {
      onClick: closePopup
    }, t("editor.map_background_sound_cancel"))))
  }));
});